(function () {
  function initBar(bar) {
    // 幂等：脚本重复加载（多 section 实例）或 editor 重新注入时只初始化一次
    if (bar.dataset.pillarAnchorInit === 'true') return;
    bar.dataset.pillarAnchorInit = 'true';

    const links = Array.from(bar.querySelectorAll('[data-pillar-anchor-link]'));
    if (!links.length) return;

    const items = links.map((link) => {
      const href = link.getAttribute('href') || '';
      const id = href.startsWith('#') ? href.slice(1) : '';
      const target = id ? document.getElementById(id) : null;
      return { link, id, target };
    });

    items.forEach((it) => {
      if (it.id && !it.target) {
        const li = it.link.closest('.pillar-anchor-bar__item');
        if (li) li.hidden = true;
      }
    });

    const valid = items
      .filter((it) => it.target)
      .sort((a, b) => {
        const at = a.target.getBoundingClientRect().top + window.scrollY;
        const bt = b.target.getBoundingClientRect().top + window.scrollY;
        return at - bt;
      });
    if (!valid.length) return;

    const barHeight = () => bar.getBoundingClientRect().height;

    let lockUntil = 0;
    const LOCK_MS = 900;

    valid.forEach((it) => {
      it.link.addEventListener('click', (e) => {
        e.preventDefault();
        setActive(it.link);
        lockUntil = Date.now() + LOCK_MS;
        const top = it.target.getBoundingClientRect().top + window.scrollY - barHeight() - 4;
        window.scrollTo({ top, behavior: 'smooth' });
        if (it.id) history.replaceState(null, '', '#' + it.id);
      });
    });

    function setActive(active) {
      links.forEach((l) => l.classList.toggle('is-active', l === active));
    }

    function onScroll() {
      if (Date.now() < lockUntil) return;
      const offset = barHeight() + 4;
      let current = valid[0];
      for (const it of valid) {
        const rect = it.target.getBoundingClientRect();
        if (rect.top - offset <= 0) current = it;
        else break;
      }
      setActive(current.link);
    }

    let rafId = 0;
    const schedule = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        rafId = 0;
        onScroll();
      });
    };

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    onScroll();

    // 供 shopify:section:unload 清理，避免 theme editor 中反复增删 section 时监听器泄漏
    bar.pillarAnchorCleanup = function () {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-pillar-anchor-bar]').forEach(initBar);
  }

  function teardown(root) {
    (root || document).querySelectorAll('[data-pillar-anchor-bar]').forEach((bar) => {
      if (typeof bar.pillarAnchorCleanup === 'function') bar.pillarAnchorCleanup();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Theme editor：merchant 在编辑器中拖入/移除本 section 时正确初始化与清理
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:section:unload', (e) => teardown(e.target));
})();
